
<template>
	<c-dialog ref="dialog" title="选择订单产品" width="100vw-300" height="800" enable-flex @resolve="resolve">
		<module drag="disabled">
			<module-col size="300" enable-flex>
				<m-search ref="search" column="1" :reset="false" :default-data="{'order_states': [2]}" @search="$refs.page.update(1)">
					<m-search-item>
						<c-input name="keyword" maxlength="50" placeholder="搜索关键字"></c-input>
					</m-search-item>
					<m-search-item>
						<c-checkbox-group name="order_states">
							<c-checkbox value="2">仅查询执行中的订单</c-checkbox>
						</c-checkbox-group>
					</m-search-item>
				</m-search>
				<div class="order-list flex-grow">
					<ul>
						<li v-for="(item, i) in orderList" :key="i" class="flex-center-cross">
							<c-checkbox :value="!!currentOrder.find(temp => temp.id == item.id)" @change="orderHandle(arguments[0], [item])"></c-checkbox>
							<div class="flex-grow">
								<p>{{item.order_code}}</p>
								<p>{{item.customer_name}}</p>
							</div>
							<c-state dict="salesOrderStateDic" :value="item.order_state"></c-state>
						</li>
					</ul>
				</div>
				<c-pagination ref="page" page-size="20" :total="orderTotal" @handle="updateOrder"></c-pagination>
			</module-col>
			<module-col>
				<c-tips>当前界面按已选订单展示产品bom结构及当前库存情况（红色表示库存不足）</c-tips>
				<dl v-for="(order, i) in currentOrder" :key="order.id" class="order-product">
					<dt class="flex-center" @click="$set(order, 'fold', !order.fold)">
						<i class="icon tf">&#xe69b;</i>
						<p>{{order.order_code}}</p>
						<template v-if="order.customer_name">
							<div class="line"></div>
							<span>{{order.customer_name}}</span>
						</template>
						<div class="line"></div>
						<c-state dict="salesOrderStateDic" :value="order.order_state"></c-state>
						<div class="flex-grow"></div>
						<i class="angle" :class="[order.fold ? 'tf-angle-up' : 'tf-angle-down']"></i>
					</dt>
					<dd v-show="!order.fold">
						<c-tree ref="tree" :data="order.childProduct" :icon="false" :select="false" :check="{linked: false, clickCheck: true}">
							<template #default="{data, pId}">
								<div class="item flex-center-cross">
									<c-state dict="productSourceName" :value="data.product_source"></c-state>
									<!-- <c-state dict="productTypeName" :value="data.product_type"></c-state> -->
									<p>{{data.product_code}}</p>
									<div class="line"></div>
									<p style="color: #999;">{{data.product_name}}</p>
									<p v-if="data.product_spec" style="color: #999;">[{{data.product_spec}}]</p>
									<template v-if="pId">
										<div class="line"></div>
										<p>单位用量：<span style="color: var(--color-blue)">{{data.unit_count}}</span></p>
									</template>
									<div class="line"></div>
									<p>总量：<span style="color: var(--color-blue)">{{data.main_product_count}}{{data.unit}}</span></p>
									<div class="line"></div>
									<p>库存数量：<span :style="{'color': data.product_count < data.main_product_count ? '#f55' : ''}">{{data.product_count}}</span></p>
								</div>
							</template>
						</c-tree>
					</dd>
				</dl>
			</module-col>
		</module>
	</c-dialog>
</template>

<script>
	import {mapState} from 'vuex'
	
	export default {
	    name: 'orderProductSelector',
		
		data() {
			return {
				orderList: [],
				currentOrder: [],

				orderTotal: 0
			}
		},

		computed: {
			...mapState(['productTypeName'])
		},
		
		methods: {
			open(data = {}) {
				this.orderList = [];
				this.currentOrder = [];
				this.$refs.dialog.open();
				this.$refs.search.clear();
				this.$refs.search.search();
				if (data.orderList && data.orderList.length) {
					this.orderHandle(true, data.orderList);
				}
			},
			
			updateOrder(data) {
				this.orderList = [];
				this.request({
					url: '/order/selectList',
					data: Object.assign({}, this.$refs.search.get(), data),
					success: data => {
						this.orderList = data;
					},
					response: res => {
						this.orderTotal = res.total;
					}
				});
			},

			orderHandle(state, list) {
				if (state) {
					if (!this._request) {
						this._request = {};
					}
					this._request[list[0].id] = this.request({
						url: '/order/productBom',
						data: {
							order_ids: list.map(data => data.id)
						},
						success: data => {
							data.forEach(order => {
								function loop(list, parent) {
									if (list) {
										return list.map(item => {
											item.order_product_id = item.id;
											item.unit_count = item.unit_count || 1;
											item.main_product_count = parent ? parseFloat((parent.main_product_count * item.unit_count).toFixed(4)) : item.main_product_count;
											
											return {
												id: item.id || item.product_id,
												pId: parent ? parent.id : 0,
												data: item,
												[item.childProduct ? 'children' : 'leaf']: item.childProduct ? loop.call(this, item.childProduct, item) : true
											}
										})
									}
								};
								order.childProduct = loop.call(this, order.childProduct);
								this.currentOrder.push(order);
							});
							this.$nextTick(() => {
								this.$refs.tree.forEach(item => {
									item.expandNode();
								});
							});
						}
					})
				} else {
					list.forEach(data => {
						let index = this.currentOrder.findIndex(item => item.id == data.id);
						if (index > -1) {
							this.currentOrder.splice(index, 1);
							this._request[data.id] && this._request[data.id].abort();
						}
					});
				}
			},
			
			resolve(stop) {
				let data = [];
				this.$refs.tree.forEach(item => {
					data = data.concat(item.getNode('checked'));
				});
				if (!data.length) {
					stop();
					this.$message({
						message: '请选择产品'
					});
					return;
				}
				this.$emit('resolve', data.map(item => {
					return item.data;
				}));
			},
		}
	}
</script>

<style lang="stylus" scoped>
	.order-list {
		border-top: 1px solid #eee;
		overflow: auto;

		li {
			height: 64px;
			border-bottom: 1px solid #eee;
			padding: 0 20px;

			p {
				margin-left: 10px;
				line-height: 20px;
				font-size: 13px;
				color: #333;
			}
		}
	}

	>>> .c-pagination {
		border-top: 1px solid var(--unit-border);

		.c-select {
			display: none;
		}
	}

	.order-product {
		dt {
			z-index: 10;
			position: sticky;
			top: 36px;
			gap: 8px;
			height: 40px;
			border: 1px solid var(--unit-line);
			border-width: 1px 0;
			padding: 0 16px;
			background: #FAFAFA;
			cursor: pointer;

			^[-1]:nth-child(1) ^[-1..-1] {
				border-top: none;
			}

			.icon {
				font-size: 18px;
				color: var(--color-main);
			}

			.line {
				width: 1px;
				height: 14px;
				background: #ccc;
			}

			.angle {
				color: #999;
			}
		}

		dd {
			overflow: auto;

			>>> .c-tree {
				margin: 12px;
			}

			.item {
				gap: 8px;
				white-space: nowrap;

				.line {
					width: 1px;
					height: 14px;
					background: #ccc;
				}
			}
		}
	}
</style>